module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-pdf-7c49e160.svg";